'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mapValues = require('lodash/fp/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapValuesWithKey = _mapValues2.default.convert({ cap: false });
var linkHandlersAfter = mapValuesWithKey(function (handler, name) {
  return function (props) {
    return function () {
      if (props[name]) props[name].apply(props, arguments);
      handler(props).apply(undefined, arguments); // memoize(handler)(props)?
    };
  };
});

exports.default = linkHandlersAfter;


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/linkHandlersAfter.js
// module id = 1691
// module chunks = 0